/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Ansprechperson (Ansprechperson)
 * 
 * 401130001 = WeitereAnsprechperson (Weitere Ansprechperson)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceIdentischmit {
 Ansprechperson = 401130000,
 WeitereAnsprechperson = 401130001
}

marker([
    "Enum.GlobalEnumsAceIdentischmit.Ansprechperson",
    "Enum.GlobalEnumsAceIdentischmit.WeitereAnsprechperson"
]);

export namespace GlobalEnumsAceIdentischmit
{
    class DataSets
    {
        static GlobalEnumsAceIdentischmitDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Ansprechperson", 401130000, "Ansprechperson"),
            new EnumValue("WeitereAnsprechperson", 401130001, "Weitere Ansprechperson"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceIdentischmitDataSet;
    }
}
